const messages = {
  message(resp, defaultMsg) {
    let success = resp.status >= 200 && resp.status < 300,
      type = success ? 'success' : 'failure',
      msgSize = resp.data && resp.data.messages && resp.data.messages.length,
      msg = msgSize ? resp.data.messages[msgSize - 1].msg : defaultMsg
    msg = msg || (success ? '操作成功' : '操作失败')
    return { type: type, message: msg }
  },
  /**
   * 获取默认主消息
   * @param {*} resp 对应响应中的response
   * @param {*} defaultMsg res没有消息时返回的默认消息
   */
  getMainMessage(resp, defaultMsg) {
    if (resp.data && resp.data.messages && resp.data.messages.length) {
      return resp.data.messages[0].msg
    }
    return defaultMsg
  },
  /**
   * 获取额外消息中指定key的第一条消息，额外消息是一个json对象
   * @param {*} resp 对应响应中的response
   * @param {*} key 额外消息的key值
   * @param {*} defaultMsg
   * return string
   */
  getExtraMessage(resp, key, defaultMsg) {
    if (resp.data && resp.data.extra_message && resp.data.extra_message[key]) {
      return resp.data.extra_message[key][0].msg
    }
    return defaultMsg
  },
  /**
   * 获取额外消息中指定key的所有消息，额外消息是一个json对象
   * @param {*} resp 对应响应中的response
   * @param {*} key 额外消息的key值
   * return array
   */
  getExtraMessageAll(resp, key) {
    if (resp.data && resp.data.extra_message && resp.data.extra_message[key]) {
      let msgs = []
      let msg_objs = resp.data.extra_message[key]
      msg_objs.forEach(item => {
        msgs.push(item.msg)
      })
      return msgs
    }
    return []
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/api/messages.js